import { Directive } from "@angular/core";

/**
 * Helper directive to select card action if required
 * for skus and plans
 */
@Directive({
    selector: "[sharedCardAction]",
})
export class DeloitteAiCardActionDirective {}
